<template>
    <div class="split content split-horizontal second-wishlist" id="charScreeen">
        <span style="display:none;">{{ create_liveCandle }}</span>
        <!-- {{set_order_draw_line}} -->
        <chart-loader v-if="loading == 1"></chart-loader>
        <div class="TVChartContainer comPopup" ref="chartContainer" />

        
    </div>
    <!--split_b-->
</template>
<style>
    #app-custom-view .TVChartContainer.comPopup{
        height: 100%;
    }
</style>
<!-- <script src="../../../../static/website/js/chartIQ/stxThirdParty.js"></script>
<script src="../../../../static/website/js/chartIQ/stxTimeZoneData.js"></script>
<script src="../../../../static/website/js/chartIQ/stx.js"></script>
<script src="../../../../static/website/js/chartIQ/stxKernelOs.js"></script>
<script src="../../../../static/website/js/chartIQ/stxLibrary.js"></script> 
<script src="../../../../static/website/js/chartIQ/stxAdvanced.js"></script> -->
<script>
import app_alerpop from './price-alert'
import buy_sell from './buy-sell'
import { Const } from '@/plugins/vue-provider-cache/const.mod'
// var Stx = require('../../../../static/website/js/stx.js')
import { commonAllmixins } from '@/plugins/commonAll'
import moment from 'moment'
export default {
    name: 'Chart-page',
    mixins: [commonAllmixins],
    data() {
        return {
            feed : null,
            ChartData : [],
            intervalJson : {
                "1" : '1m',
                "5" : '5m',
                "15" : '15m',
                "30" : '30m',
                "60" : '1h',
                "120" : '2h',
                "240" : '4h',
                "480" : '8h',
                "1D" : '1day',
                "1W" : '1week',
                "1M" : '1month',
                "12M" : '1year',
            },
            tvWidget: null,
            searchdata : [],
            info : {},
            searchSymbol : '',
            lastBar: '',

            currentInterval: '',
            // chartType: 'USD-BTC',
            pageLoader:false,
            upButton:false,
            downButton:true,
            buySellType: 'buy',

			loading: 1,
            tradeBuySell: false,

			stxx : "",
            // "loadChart" : "EURUSD"
            // "loadChart" : "BTC-USD",
            intervalPeriod: 60,
            intervalTitle:{
                '1M':'1 Minute',
                '1H':'1 Hour',
                '1D':'1 Day',
                '1W':'1 Week',
                '1MN':'1 Month',
            },
            positionList : [],
            stopLossList : [],
            TakeProfitList : [],
            pendingOdList : [],
            chartInterval: [
				{'unit':1,'name':'minute',data:'1M'},
				{'unit':1,'name':'hour',data:'1H'},
				{'unit':1,'name':'day',data:'1D'},
				{'unit':1,'name':'week',data:'1W'},
				{'unit':1,'name':'month',data:'1MN'}
            ],
            defaultChartInterval: '1',
            search:'',
            searchPopUp:false,
            ShowSearchPopup:false,
            ChartValues:{Open:'',High:'',Low:'',Close:''},
            // fullscreen: false,
            tools: ["", "crossline", "trendline", "fibfan", "freeform", "annotation", 'fibonacci', "gannfan", "average", "line", ""],
            chartType:'candle',
            chartTypelist:[
                {type:'candle', value:'Candle', class:'icon-candle'},
                {type:'hollow_candle', value:'Hollow Candle', class:'hollow-candle'},
                {type:'mountain', value:' Mountain', class:'icon-area'},
                {type:'colored_line', value:'Line', class:'icon-line'},
                {type:'colored_bar', value:'Bar', class:'icon-bar'},
                {type:'baseline_delta', value:'Baseline Delta', class:'icon-baseLine'},
                // {type:'histogram', value:'Histogram', class:''},
                // {type:'wave', value:'Wave', class:''}
            ],
            searchStudy:'',
            studiesAddedList:[],
            studies_List:{},
            alertTab: false,
            studyDialogOpened: false,
            chartReady: false,
            toolSelected: '-',
            ticks : 70,
            showLine: false,
            ShowUploads: false,
            showCreateLayout: false,
            saveAsLayout: false,
            new_layout_name:'',
            submitted: false,
            layoutSelected:'',
            saveCurrentlayout: false,
            renamelayout:{},
            studdyActive: false,
            OldTrade: '',
            lastMin: -1,
            IsLineDraw : false,
            
		}
    },
    components:{
    	appAlerpop : app_alerpop,
        AppBuySell : buy_sell
    },
    props:['loadChart','mn'],
    watch:{
        appTheme(val){
            this.chartColor()
        },
    	loadChart(val){
            this.searchSymbol = ''
            this.changeNewChart()
            this.chartReady = true
           
    	},
    },
    methods:{
        loadScripts() {
            return Promise.all([
            this.loadScript('/charting_library/charting_library.standalone.js'),
            this.loadScript('/datafeeds/udf/dist/bundle.js'),
            ]);
        },
        loadScript(src) {
            return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.type = 'text/javascript';
            script.onload = resolve;
            script.onerror = reject;
            document.body.appendChild(script);
            });
        },
        layoutName(){
            return (this.getCurrentLayout().slice(0,10) || '') + ((this.getCurrentLayout().length > 10)?'...':'')
        },
        renameClick(){
            if(this.layoutSelected){
                this.renamelayout = this.getLayoutList().filter(item=>this.layoutSelected == item.id)[0]
            }else{
                this.saveLayoutClick()
            }
        },
        saveRenamelayout(){
            let _that = this
            let totalData = _that.getRawData()
            let getIndex = totalData.view_mode.chart_layout.findIndex(item=>_that.layoutSelected == item.id)
            totalData.view_mode.chart_layout[getIndex]['layout_name'] = this.renamelayout.layout_name
            totalData.view_mode.chart_layout[getIndex]['lastModify'] = Date.now()
            _that._runSetRawObject({ 'globalParams' : {'setting': totalData},'localParams' : {'parameter' : this} })
        },
        saveAsClick(){
            if(this.layoutSelected){
                let data = this.getLayoutList().filter(item=>this.layoutSelected == item.id)[0]
                this.new_layout_name = (data.layout_name+ ' Copy').slice(0, 20)
                this.saveAsLayout = true
                this.showCreateLayout = true
            }else{
                this.saveLayoutClick()
            }
        },
        getCurrentLayout(){
            try{
                return this.getLayoutList().filter(item=>this.layoutSelected == item.id)[0].layout_name
            }catch(e){ return '' }
        },
        getLayoutList(){
            try{
                return this.getRawData().view_mode.chart_layout
            }catch(e){ return [] }
        },
        rawObjectSaved(){ // 
            if(this.showCreateLayout){
                this.submitted =  true
                this.saveAsLayout =  true
                this.showCreateLayout =  ''
                this.new_layout_name =  ''
                this.displayError('New Layout Created successfully','success')
            }
            if(this.saveCurrentlayout){
                this.displayError('Layout saved successfully','success')
                this.saveCurrentlayout = false
            }
            if(this.ShowUploads){
                this.displayError('Layout Removed successfully','success')
                this.ShowUploads = false
            }
            if(Object.keys(this.renamelayout).length > 0){
                this.displayError('Layout Renamed successfully','success')
                this.renamelayout = {}
            }
        },
        saveLayoutClick(){
            var drawingList = this.stxx.exportDrawings();
            var studiesList = this.stxx.exportLayout();
            if(drawingList.length || Object.keys(studiesList .studies).length > 0){
                if(this.layoutSelected){
                    this.savelayout()
                }else{
                    this.showCreateLayout = true
                }
            }else{
                this.displayError('No Indicator or Drawing applied yet.','error')
            }
        },
        closeCreate(){
            this.showCreateLayout = false;
            this.saveAsLayout = false;
            this.new_layout_name = ''
        },
        createNewlayout(){
            this.submitted =  true
            let _that = this
            _that.$validator.validate().then(valid => {
                if (valid) {
                    var drawingList = _that.stxx.exportDrawings();
                    var studiesList = _that.stxx.exportLayout();
                    if(drawingList.length || Object.keys(studiesList .studies).length > 0){
                        let data = {
                            id : Date.now(),
                            layout_name : _that.new_layout_name,
                            symbol : _that.loadChart,
                            mn : _that.mn,
                            description : _that.instruments[_that.loadChart].other.Description,
                            layout : {},
                            lastModify: Date.now()
                        }
                        if(drawingList.length > 0){ data.layout['drawingList'] = drawingList }                         // to save drawing
                        if(Object.keys(studiesList .studies).length > 0){ data.layout['studiesList'] = studiesList  }   // to save studies

                        let totalData = _that.getRawData()
                        totalData.view_mode.chart_layout.push(data)

                        _that.layoutSelected = data.id
                        _that._runSetRawObject({ 'globalParams' : {'setting': totalData},'localParams' : {'parameter' : this} })
                    }
                }
            });
        },
        savelayout(){
            let _that = this
            var drawingList = _that.stxx.exportDrawings();
            var studiesList = _that.stxx.exportLayout();
            if(drawingList.length || Object.keys(studiesList .studies).length > 0){
                let totalData = _that.getRawData()
                let getIndex = totalData.view_mode.chart_layout.findIndex(item=>_that.layoutSelected == item.id)

                if(drawingList.length > 0){// to save drawing
                    totalData.view_mode.chart_layout[getIndex].layout['drawingList'] = drawingList
                }else{ totalData.view_mode.chart_layout[getIndex].layout['drawingList'] = null }

                if(Object.keys(studiesList .studies).length > 0){   // to save studies
                    totalData.view_mode.chart_layout[getIndex].layout['studiesList'] = studiesList
                }else{ totalData.view_mode.chart_layout[getIndex].layout['studiesList'] = null }
                totalData.view_mode.chart_layout[getIndex]['lastModify'] = Date.now()
                this.saveCurrentlayout = true
                _that._runSetRawObject({ 'globalParams' : {'setting': totalData},'localParams' : {'parameter' : this} })
            }
        },
        removelayout(ID){
            let _that = this
            let totalData = _that.getRawData()
            totalData.view_mode.chart_layout = totalData.view_mode.chart_layout.filter(item=> item.id != ID)
            if(this.layoutSelected = ID){
                this.layoutSelected = ''
            }
            _that._runSetRawObject({ 'globalParams' : {'setting': totalData},'localParams' : {'parameter' : this} })
        },
        selectLayout(val){
            if(this.loadChart != val.symbol){
                this.layoutSelected = val.id
                this.$emit("input",{ 'key':val.symbol, 'mn':val.mn})
                this.ShowUploads = false
            }else if(this.layoutSelected != val.id){
                this.layoutSelected = val.id
                this.ShowUploads = false
                this.applyloadedLayout()
            }
        },
        applyloadedLayout(){
            const _that = this
            try{
                for (var studyInstanceName in _that.stxx.layout.studies) {
                    var sd = _that.stxx.layout.studies[studyInstanceName];
                    _.CIQ.Studies.removeStudy(_that.stxx, sd);
                }
            }catch(e){}
            if(this.layoutSelected){
                let data = _that.getLayoutList().filter(item=>_that.layoutSelected == item.id)[0]
                if(data.symbol == _that.loadChart){
                    setTimeout(function(){
                        try{
                            if(data && data.layout){
                                _that.showLine = false;
                                if(data.layout['studiesList']){
                                    var importOptions = {
                                        managePeriodicity: true,
                                        preserveTicksAndCandleWidth: true
                                    };
                                    _that.stxx.importLayout(data.layout['studiesList'],importOptions)
                                    _that.chartType = data.layout['studiesList'].chartType
                                    /*if(!data.layout.hasOwnProperty('drawing') ){
                                        _that.showLine = true;
                                    }*/
                                }
                                if(data.layout['drawingList']){
                                    // _that.stxx.reconstructDrawings(data.layout['drawingList'])
                                    _that.stxx.importDrawings(data.layout['drawingList'])
                                    _that.stxx.changeVectorType('');
                                    let interval = setInterval(function(){
                                        if(_that.stxx.exportDrawings().length == 0){
                                            // _that.stxx.reconstructDrawings(data.layout['drawingList'])
                                            _that.stxx.importDrawings(data.layout['drawingList']);
                                            _that.stxx.changeVectorType('');
                                        }else{
                                            // _that.showLine = true;
                                            clearInterval(interval);
                                        }
                                    }, 100);
                                }
                            }else{
                                _that.changeChartType('candle');
                                // _that.showLine = true;
                            }
                        } catch(e){              
                            console.log(e)
                        } 
                    }, 300);
                }else{
                    _that.layoutSelected = ''
                }
            }
        },
    	changeCrosshair(){
    		if(this.stxx.layout.crosshair){
    			this.stxx.layout.crosshair = true;
    		}else{
    			this.stxx.layout.crosshair = false;
    		}
    	},
    	getCrosshair(){
    		try{
    			return this.stxx.layout.crosshair
    		}catch(e){
    			return false
    		}
    	},// this.stxx.layout.crosshair = true;
    	create_image(){
    		var stx = this.stxx
		    var link = document.createElement('a');
		  	link.download = 'filename.jpeg';
		  	link.href = stx.chart.canvas.toDataURL("image/png")
		  	link.click();
    	},
        dismissDialog(){
            Stx.STX.DialogManager.dismissDialog()
            this.studyDialogOpened = false
        },
    	createStudy(){
            /*// var div = document.getElementById('studyDialog')
            const div = this.$refs.studyDialog
            // console.log('div-ref',div)
			var a = Stx.STX.Studies.go(div, this.stxx);	// Note, please add stxx as second parameter in order to translate studies
            // console.log('STX.Studies.go--->',a)
            // console.log('STX.Studie--->',_.CIQ.Studies.studyLibrary[div.study])
            // console.log('a--------------->',a)
            this.applyStudy(a,div.study)
            // console.log('2',div.study)
            // Stx.STX.Studies.go(Stx.$$("studyDialog"), this.stxx);  // Note, please add stxx as second parameter in order to translate studies*/
            var a = Stx.STX.Studies.go(Stx.$$("studyDialog"), this.stxx)
            if(a.inputs){
                this.applyStudy(a,Stx.$$("studyDialog").study)
            }
			Stx.STX.DialogManager.dismissDialog()
			this.studyDialogOpened = false
		},
        applyStudy(value,name){
            for(var type in value){
            	// console.log(type,'=>')
            	for(var std in value[type]){
            		// console.log(std,':- ',value[type][std])
            		_.CIQ.Studies.studyLibrary[name][type][std] = value[type][std]
            	}
            }
            // _.CIQ.Studies.removeStudy(this.stxx, name)
            _.CIQ.Studies.addStudy(this.stxx, name)//, null, null, { display: name }
            this.studdyActive = true
            // var params = { stx: stx, sd: sd, inputs: inputs, outputs: outputs, parameters: parameters };
        },
        addStudie(studie){
            var _that =  this
            var study = studie
            if(!_that.stxx || !_that.stxx.chart.dataSet) return;
            if(_.CIQ.Studies.studyLibrary[study] && _.CIQ.Studies.studyLibrary[study].name) window._.$$("studyDialog").querySelectorAll(".title")[0].innerHTML=_that.stxx.translateIf(_.CIQ.Studies.studyLibrary[study].name);
            else window._.$$("studyDialog").querySelectorAll(".title")[0].innerHTML=study.capitalize();
            Stx.STX.Studies.studyDialog(_that.stxx, study, window._.$$("studyDialog"));
            var delay=Stx.STX.ipad?400:0;  // so that ipad doesn't register taps from menu selection on dialog
            setTimeout(function(){
                Stx.STX.DialogManager.displayDialog("studyDialog");
                _that.studyDialogOpened = true
            }, delay);
        },
        removeStudy(val){
        	var study;
        	for (var studyInstanceName in this.stxx.layout.studies) {
				var sd = this.stxx.layout.studies[studyInstanceName];
				if(sd.type == val){
					study = sd
				}
			}
			if(study){
				_.CIQ.Studies.removeStudy(this.stxx, study)
			}
        	this.studiesAddedList = this.studiesAddedList.filter(data => data != val)
        },
        ChartName(chartType){
            return this.chartTypelist.filter(val=>val.type == chartType)[0].value //value
        },
        ChartClass(chartType){
            return this.chartTypelist.filter(val=>val.type == chartType)[0].class //value
        },
        changeChartType(type){
            this.chartType = type
            this.stxx.setChartType(type)
        },
        openFullscreen() {
            if(document.fullscreenElement){
                document.exitFullscreen();
            }else{
                var elem = document.getElementById("charScreeen");
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) { /* Safari */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE11 */
                    elem.msRequestFullscreen();
                }
            }
        },
        drop(ev){
            var data = ev.dataTransfer.getData("marketData");
            if(data){
                this.$emit("input", JSON.parse(data))
            }
        },
        enableDrawingTool: function(tool){
            if(this.toolSelected == tool){
                this.toolSelected = '-'
                this.stxx.changeVectorType('');
            }else if(tool){
                this.toolSelected = tool
                this.stxx.changeVectorType(tool);
            }
            this.stxx.currentVectorParameters.pattern = "solid";

            if (tool === '' && this.stxx.drawingObjects.length!=0) {
                this.stxx.removeDrawing(this.stxx.drawingObjects[this.stxx.drawingObjects.length-1]);
                /*var numDrawings = this.stxx.drawingObjects.length; // changes as each drawing is removed
                for (var i=0; i < numDrawings; i++) {
                  this.stxx.removeDrawing(this.stxx.drawingObjects[0]);
                }
                tool = "off";*/
            }
        },
        displayError(getMessage,type){
            this.$notify({
                group: 'foo',
                type: (type && type == null)?'error':type,
                text: getMessage,
                duration: 3000,
                closeOnClick: true
            });
        },
        // changeNewChart(){
        //     this.showLine = false
        //     const _her = this
        //     setTimeout(function(){
        //         try{
        //             _her.loading = 1
        //             let chartName = _her.mn ? _her.mn : _her.loadChart
        //             if(this.defaultChartInterval == '1M'){
        //                 this.stxx.setMaxTicks(300);
        //             }
        //             _her.stxx.newChart(chartName, null, null, function () {
        //                 _her.loading = 0
        //                 _her.applyloadedLayout()
        //             });
        //         } catch(e){              
        //             // console.log(e)
        //         } 
        //     }, 300);
        // },
		changeInterval(value){
            if(this.defaultChartInterval != value.data){
                if(this.defaultChartInterval == value.data){ return }
    			this.defaultChartInterval = value.data;
    			var intval = value.unit
    			var tUnit = value.name
                let valInter = 1
    			if(tUnit == "hour"){
    				intval = 60;
    				tUnit = "minute";
                }

                if(tUnit == '1W'){
                    intval = 7;
                    tUnit = "day";

                }
                
                if(tUnit == '1MN'){
                    intval = 30;
                    tUnit = "day";

                }

                if(value.name == 'minute'){
                    this.stxx.setMaxTicks(300);
                    this.ticks = 300
                }
    			// console.log('data',{period:1, interval:intval, timeUnit:tUnit})
    			// this.stxx.setPeriodicity({period:1, interval:1, timeUnit:"day"});
    			this.stxx.setPeriodicity({period:intval, interval:valInter, timeUnit:tUnit});
            }
		},
        chartColor(){
            try{
                let text = '', grid = ''

                const _that = this
                // if(this.$root.$children[0].theme){
                //     text = '#dee2e6'
                //     grid = '#29324F'
                // }else{
                //     text = '#BABCC4'
                //     grid = '#F2F3F3'
                // }
                // this.stxx.setStyle("stx_xaxis_dark","color", text); 
                // this.stxx.setStyle("stx_xaxis","color", text); 
                // this.stxx.setStyle("stx_yaxis_dark","color", text); 
                // this.stxx.setStyle("stx_yaxis","color", text); 
                // this.stxx.setStyle("stx-panel-control","color", text); 
                
                // this.stxx.setStyle("stx_grid","color", grid);
                // this.stxx.setStyle("stx_grid_dark","color", grid);
                let themeStyle = getComputedStyle(document.body)

                // this.tvWidget =new TradingView.widget({"toolbar_bg": themeStyle.getPropertyValue('--primary-color')});
                
                const container = _that.$refs.chartContainer;
                var widgetOptions = {
                    library_path: '../../../../static/website/js/charting_library/',
                    // debug: true, // uncomment this line to see Library errors and warnings in the console
                    fullscreen: true,
                    symbol: _that.loadChart || _that.info.other.isinid,
                    interval: '1D',
                    container: container,
                    datafeed: _that.feed,
                    locale: "en",
                    // disabled_features: ['header_compare', 'header_widget'],
                    enabled_features: ["save_chart_properties_to_local_storage","saveload_separate_drawings_storage","header_saveload"],
                    theme: "dark",
                    time_frames: [
                        { text: "1d", resolution: "1", description: "1 day" },
                        { text: "5d", resolution: "5", description: "5 days" },
                        { text: "1m", resolution: "30", description: "1 Month" },
                        { text: "3m", resolution: "60", description: "3 Months" },
                        { text: "6m", resolution: "120", description: "6 Months" },
                        { text: "1Y", resolution: "1D", description: "3 Years" },
                        { text: "5Y", resolution: "1W", description: "5 Years" },
                    ],
                    autosize: true,
                    toolbar_bg: themeStyle.getPropertyValue('--primary-color'),
                    overrides: {}
                };
                // console.log('===>',widgetOptions)
                const tvWidget = new TradingView.widget(widgetOptions);
                tvWidget.onChartReady(() => {
                    _that.tvWidget = tvWidget;

                    tvWidget.applyOverrides({
                        "paneProperties.backgroundGradientStartColor": themeStyle.getPropertyValue('--secondary-color'),
                        "paneProperties.backgroundGradientEndColor": themeStyle.getPropertyValue('--secondary-color'),
                        "toolbar_bg": themeStyle.getPropertyValue('--primary-color'),
                        "paneProperties.vertGridProperties.color": themeStyle.getPropertyValue('--primary-color')
                    });
                });

                // this.tvWidget.applyOverrides({
                //     "paneProperties.backgroundGradientStartColor": themeStyle.getPropertyValue('--secondary-color'),
                //     "paneProperties.backgroundGradientEndColor": themeStyle.getPropertyValue('--secondary-color'),
                //     "mainSeriesProperties.toolbar_bg": themeStyle.getPropertyValue('--primary-color'),
                //     "paneProperties.toolbar_bg": themeStyle.getPropertyValue('--primary-color')
                // });

                //dee2e6 text
                //29324F grid
            }catch(e){}
        },
		initalizeChart: function(){
			// this.stxx = new STXChart({container:$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true}});
            this.stxx = new window._.CIQ.ChartEngine( { container: window._.$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true} } );
            // this.stxx = new window._.STXChart( { container: window._.$$$(".chartContainer"), layout:{"candleWidth": 16, "crosshair":true} } );
			if(this.stxx.controls.chartControls){
				// stxx.controls.chartControls.style.display="block";        // use this line to enable the controls
				this.stxx.controls.chartControls.style.display="none";        // use this line to disable the controls
			}
			this.stxx.chart.xAxis.displayGridLines=true;
			this.stxx.chart.yAxis.displayGridLines=true;
			
            // for hollow candle
            this.stxx.setStyle("stx_hollow_candle_up","color", '#10BD72');
			this.stxx.setStyle("stx_hollow_candle_down","color", '#F25767');

            // for mountain
            this.stxx.setStyle("stx_mountain_chart", "border-top-color", '#10BD72');
            // for line chart 
            this.stxx.setStyle("stx_line_up", "color", '#10BD72');
            this.stxx.setStyle("stx_line_down", "color", '#F25767');
            // for bar chart 
            this.stxx.setStyle("stx_bar_up", "color", '#10BD72');
            this.stxx.setStyle("stx_bar_down", "color", '#F25767');
            // for base line delta chart
            this.stxx.setStyle("stx_baseline_up", "color", '#10BD72');
            this.stxx.setStyle("stx_baseline_down", "color", '#F25767');


			this.stxx.setChartType('candle');
            this.stxx.setStyle("stx_candle_up","border-left-color", '#66000000');
            this.stxx.setStyle("stx_candle_down","border-left-color", '#66000000'); 
            this.stxx.setStyle("stx_candle_up","color", '#10BD72');
			this.stxx.setStyle("stx_candle_down","color", '#F25767');
			this.stxx.setStyle("stx_candle_shadow_up","color", '#10BD72');
			this.stxx.setStyle("stx_candle_shadow_down","color", '#F25767');
            this.chartColor()



			this.stxx.chart.xAxis.axisType="ntb";
			this.stxx.chart.yAxis.goldenRatioYAxis=true;
            // this.stxx.chart.xAxis.futureTicks=false;
            
			this.stxx.chart.yAxis.position="right";
			this.stxx.allowEquations = false;
            // this.stxx.yaxisLeft = 0;
            // this.stxx.chart.yAxis.justifyRight = true;
            // this.stxx.allowEquations = true;
            // this.stxx.preferences.whitespace = 0;
            // this.stxx.chart.yAxis.yaxisLabelStyle = "rect";



            // quoteFeedSimulator.url="https://dev.finvasia.com:5000/api/provider/charting";
            // __.quoteFeedSimulator.url=this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].settings.patchers.SecurityMasterPatcher.DW_HOST+"/api/provider/charting";
            __.quoteFeedSimulator.url = process.env.LIVE_CHART_URL;
            // if(this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].settings.patchers.SecurityMasterPatcher.DW_HOST){
            //     __.quoteFeedSimulator.url = this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].settings.patchers.SecurityMasterPatcher.DW_HOST+"/api/provider/charting";
            // }
            
            //quoteFeedSimulator.url="https://portfolios.com:2087/api/provider/charting";

            __.quoteFeedSimulator.url += "?session=" + __.quoteFeedSimulator.generateGUID(); // add on unique sessionID required by ChartIQ simulator;


			this.stxx.attachQuoteFeed(__.quoteFeedSimulator,{refreshInterval:this.intervalPeriod,bufferSize:60});
			this.stxx.setMarketFactory(window._.CIQ.Market.Symbology.factory);
            // this.stxx.setMarketFactory(window._.STX.Market.Symbology.factory);
			// this.stxx.chart.yAxis.initialMarginTop=60;

			//this.stxx.setMaxTicks(60);
			//this.stxx.cleanupGaps = "carry";

			// this.stxx.setPeriodicity({period:1, interval:1, timeUnit:"minute"});
			// this.stxx.setPeriodicityV2({period:1, interval:1, timeUnit:"day"});
            this.stxx.setPeriodicity({period:1, interval:1, timeUnit:"day"});
			// this.stxx.setPeriodicity({period:2, timeUnit:'minute',interval:30})
			// this.stxx.setStyle("stx_line_chart","color","#10BD72");
			// this.stxx.setStyle("stx_line_chart","width", 2);  


			const _her = this
            let chartName = this.mn ? this.mn : this.loadChart
			this.stxx.newChart(chartName, null, null, function () {
				_.CIQ.Drawing.prototype.dragToDraw=true;


                _.CIQ.ChartEngine.prototype.append("draw", function(){
                      // _her.drawLine(1.3568,0)
                      // _her.drawLine(1.3568,0)

                });
				_her.loading = 0
                _her.chartReady = true
			});
			// this.stxx.setMaxTicks(70);
            // this.ticks = 300
            // _.CIQ.Studies.addStudy(this.stxx, "vol undr");
            this.stxx.chart.allowScrollFuture = false;
            // this.stxx.preferences.dragging = false;
            this.showLine = true;
            this.stxx.addEventListener("drawing", function() {
                _her.stxx.changeVectorType(null);
                _her.toolSelected = '-'
            });
            this.stxx.callbacks.studyOverlayEdit = function (params) {
                /*_.CIQ.alert(params.sd.name);
                var helper = new _.CIQ.Studies.DialogHelper({ name: params.sd.type, stx: params.stx });
                console.log("Inputs:", JSON.stringify(helper.inputs));
                console.log("Outputs:", JSON.stringify(helper.outputs));
                console.log("Parameters:", JSON.stringify(helper.parameters));
                // call your menu here with the  data returned in helper
                // modify parameters as needed and call addStudy or replaceStudy*/
                var stx=params.stx;
                var sd=params.sd;
                /*if(stx.openDialog) console.log(1);return; // only allow one dialog to be open
                if(params.forceEdit){
                    _her.stxx.callbacks.studyPanelEdit(params);
                    console.log(2);
                    return;
                }*/
                Stx.STX.DialogManager.displayDialog("contextMenu");
                if(_.CIQ.Studies.studyLibrary[sd.type] && _.CIQ.Studies.studyLibrary[sd.type].name) {
                    Stx.$$("contextMenu").querySelectorAll(".title")[0].innerHTML=_her.stxx.translateIf(_.CIQ.Studies.studyLibrary[sd.type].name);
                }else {
                    Stx.$$("contextMenu").querySelectorAll(".title")[0].innerHTML=sd.type.capitalize();
                }
                if(_.CIQ.Studies.studyLibrary[sd.type] && _.CIQ.Studies.studyLibrary[sd.type].name) {
                    Stx.$$("studyDialog").querySelectorAll(".title")[0].innerHTML=_her.stxx.translateIf(_.CIQ.Studies.studyLibrary[sd.type].name);
                }else {
                    Stx.$$("studyDialog").querySelectorAll(".title")[0].innerHTML=sd.type.capitalize();
                }
                var edit=Stx.$$$(".stx-edit", Stx.$$("contextMenu"));
                var remove=Stx.$$$(".stx-delete", Stx.$$("contextMenu"));
                /*Stx.STX.safeClickTouch(edit, function(){
                    Stx.STX.DialogManager.dismissDialog();
                    Stx.STX.Studies.studyDialog(stx, sd.type, Stx.$$("studyDialog"), params);
                    Stx.STX.DialogManager.displayDialog("studyDialog");
                });*/
                Stx.STX.safeClickTouch(remove, function(){
                    Stx.STX.DialogManager.dismissDialog();
                    Stx.STX.Studies.removeStudy(stx,sd);
                    /*var closeIcon=document.querySelectorAll("#menuWrapperStudies #" + sd.type.replace(" ","-"));
                    for(var c=0;closeIcon && c<closeIcon.length;c++){
                        Stx.STX.clearSafeClickTouches(closeIcon[c]);
                        closeIcon[c].style.display="";
                    }*/
                });
                // Stx.STX.DialogManager.displayDialog("contextMenu");
            }
            /*this.stxx.callbacks.studyPanelEdit = function (params) {
                var stx=params.stx;
                var sd=params.sd;
                if(_.CIQ.Studies.studyLibrary[sd.type] && _.CIQ.Studies.studyLibrary[sd.type].name){
                    Stx.$$("studyDialog").querySelectorAll(".title")[0].innerHTML=_her.stxx.translateIf(_.CIQ.Studies.studyLibrary[sd.type].name);
                }else{
                    Stx.$$("studyDialog").querySelectorAll(".title")[0].innerHTML=sd.type.capitalize();
                }
                Stx.STX.Studies.studyDialog(stx, sd.type, Stx.$$("studyDialog"), params);
                Stx.STX.DialogManager.displayDialog("studyDialog");
            }*/
            this.applyloadedLayout();
            // this.stxx.ThemeManager.builtInThemes={
            //         "White":"Light",
            //         "Black":"Dark"
            // };
            // this.stxx.ThemeManager.setThemes({"enabledTheme":"Light","customThemes":{}}, stxx);

            /*_.CIQ.Studies.studyLibrary["Plot High Low"] = {
                "seriesFN": _.CIQ.Studies.displaySeriesAsHistogram,
                inputs: {
                  "HistogramType": "clustered"
                },
                outputs: {
                  "High": "#10BD72",
                  "Low": "#F25767"
                },
                parameters:{"widthFactor":0.5},
            };*/
            // _.CIQ.Studies.addStudy(this.stxx, "Plot High Low");
            // _.CIQ.Studies.addStudy(this.stxx, "volume");
			// this.stxx.allowSideswipe = true;
			// console.log('this.stxx',this.stxx)
            // console.log(_.CIQ.Studies.studyLibrary)
            /*for(var key in _.CIQ.Studies.studyLibrary){
				this.studies_List[key] = _.CIQ.Studies.studyLibrary[key].name
            }
            console.log(this.studies_List)*/
			 /*
			     window._.CIQ.ChartEngine.prototype.prepend("headsUpHR", function prependHeadsUpHR(){
			       var tick=this.barFromPixel(this.cx);
			       var prices=this.chart.xaxis[tick];
			       window._.$$("huOpen").innerHTML="";
			       window._.$$("huClose").innerHTML="";
			       window._.$$("huHigh").innerHTML="";
			       window._.$$("huLow").innerHTML="";
			       window._.$$("huDate").innerHTML="";
			       //window._.$$("huVolume").innerHTML="";
			       if(prices){
			           if(prices.data){
			               window._.$$("huOpen").innerHTML=this.formatPrice(prices.data.Open);
			               window._.$$("huClose").innerHTML=this.formatPrice(prices.data.Close);
			               window._.$$("huHigh").innerHTML=this.formatPrice(prices.data.High);
			               window._.$$("huLow").innerHTML=this.formatPrice(prices.data.Low);
			               //window._.$$("huVolume").innerHTML=window._.CIQ.condenseInt(prices.data.Volume);
			               if(!this.chart.xAxis.noDraw){
			                   var tickDate = prices.data.displayDate;
			                   if (!tickDate) tickDate = prices.data.DT;
			                   if(this.chart.xAxis.formatter){
			                       window._.$$("huDate").innerHTML=this.chart.xAxis.formatter(tickDate);
			                   }else if(this.internationalizer){
			                       var str=this.internationalizer.monthDay.format(tickDate);
			                       if(!window._.CIQ.ChartEngine.isDailyInterval(this.layout.interval))
			                           str+=" " + this.internationalizer.hourMinute.format(tickDate);
			                       else {
			                           str=this.internationalizer.yearMonthDay.format(tickDate);
			                       }
			                       window._.$$("huDate").innerHTML=str;
			                   } else if (window._.CIQ.ChartEngine.isDailyInterval(this.layout.interval)){
			                       window._.$$("huDate").innerHTML=window._.CIQ.mmddyyyy(window._.CIQ.yyyymmddhhmm(tickDate));        
			                   } else {
			                       window._.$$("huDate").innerHTML=window._.CIQ.mmddhhmm(window._.CIQ.yyyymmddhhmm(tickDate));                    
			                   }
			               }
			           }
			       }
			     });
			 */
            
			 // $(".right_main_graph_sec").addClass('ciq-night');     
		},
        setChartValues(open,high,low,close){
            this.ChartValues.Open = parseFloat(parseFloat(open || 0).toFixed(5)) ;
            this.ChartValues.High = parseFloat(parseFloat(high || 0).toFixed(5));
            this.ChartValues.Low = parseFloat(parseFloat(low || 0).toFixed(5));
            this.ChartValues.Close = parseFloat(parseFloat(close || 0).toFixed(5));
        },
        drawOrderLine(price, side, pattern, overall,data){
            const _her = this
            // const parameters={
            // 'pattern': pattern,     // options: "solid","dashed","dotted"
            // lineWidth: 0.4            // select any with for the line
            // };
            // const x=_her.stxx.pixelFromDate(_her.stxx.chart.dataSet[_her.stxx.chart.dataSet.length-1].Date, _her.stxx.chart);
            // const y= _her.stxx.pixelFromPrice(price, _her.stxx.chart.panel,_her.stxx.chart.yAxis)

            // const color = (parseInt(side)==0)?"red":"green";        // select any color 
            // const type = "horizontal"; // don't change this setting since we are interested in drawing a horizontal line only with a _her on the y-axis
            // _her.stxx.plotLine(x, x+1, y, y, color, type, _her.stxx.chart.context, true, parameters);
 
            const color = (parseInt(side)==1)?"buy":"sell";        // select any color 
            // const type = "horizontal"; // don't change this setting since we are interested in drawing a horizontal line only with a _her on the y-axis
            // _her.stxx.plotLine(x, x+1, y, y, color, type, _her.stxx.chart.context, true, parameters);

            const bcolor = (parseInt(side)==0)?"#F25767":"#10BD72";

             let lot = overall.Quantity/_her.instruments[overall.Symbol].other.market_ContractSize
                
            let text = "Pending Order of "+color+" "+lot+"lot at "+ price
            
            // var order = _her.tvWidget.chart().createOrderLine()
            
            data.setText(text)
            .setQuantity('')
            .setPrice(price)
            .setExtendLeft(true)
            .setLineStyle(0)
            .setBodyBackgroundColor(bcolor)
            .setBodyBorderColor(bcolor)
            .setLineColor(bcolor)
            .setQuantityBackgroundColor("#1E2746")
            .setQuantityBorderColor("#000")
            .setQuantityTextColor('#fff')
            .setBodyTextColor('#fff')
        },
        drawPositionLine(price, side, pattern, overall,data){
            try{
                const _her = this
            
                const bcolor = (parseInt(side)==0)?"#F25767":"#10BD72";        // select any color 
                
                const color = (parseInt(side)==0)?"sell":"buy";        // select any color 
                let lot = overall.Quantity/_her.instruments[overall.Symbol].other.market_ContractSize
                    
                let text = color+" "+lot+"lot at "+ price
                // this.order = _her.positionList[index]
                // order.setPrice(price);
                data.setText(text)
                .setQuantity('')
                .setPrice(price)
                .setExtendLeft(true)
                .setLineStyle(0)
                .setBodyBackgroundColor(bcolor)
                .setBodyBorderColor(bcolor)
                .setLineColor(bcolor)
                .setQuantityBackgroundColor("#1E2746")
                .setQuantityBorderColor("#000")
                .setQuantityTextColor('#fff')
                .setBodyTextColor('#fff')
                // .onMove(function() {
                //     this.setText("onMove called",overall);
                // })
            }catch(e){console.log('eee',e)}

        },
        drawStopLossLine(price, side, pattern, overall,data){
            const _her = this
            const bcolor = (parseInt(side)==0)?"#F25767":"#10BD72";        // select any color 
            
            const color = (parseInt(side)==0)?"sell":"buy";        // select any color 
            
            // let lot = overall.Quantity/_her.instruments[overall.Symbol].other.market_ContractSize
                
           let text = "Stop Loss at "+ price

            // var order = _her.tvWidget.chart().createPositionLine()
            // console.log('order',order)
            // order.setPrice(price);
            data.setText(text)
            .setQuantity('')
            .setPrice(price)
            .setExtendLeft(true)
            .setLineStyle(0)
            .setBodyBackgroundColor(bcolor)
            .setBodyBorderColor(bcolor)
            .setLineColor(bcolor)
            .setQuantityBackgroundColor("#1E2746")
            .setQuantityBorderColor("#000")
            .setQuantityTextColor('#fff')
            .setBodyTextColor('#fff')
        },
        drawTakeProfitLine(price, side, pattern, overall,data){
            const _her = this
            
            const bcolor = (parseInt(side)==0)?"#F25767":"#10BD72";        // select any color 
            
            const color = (parseInt(side)==0)?"sell":"buy";        // select any color 
            
            // let lot = overall.Quantity/_her.instruments[overall.Symbol].other.market_ContractSize
                
           let text = "Take Profit at "+ price

            // var order = _her.tvWidget.chart().createPositionLine()
            // console.log('order',order)
            // order.setPrice(price);
            data.setText(text)
            .setQuantity('')
            .setPrice(price)
            .setExtendLeft(true)
            .setLineStyle(0)
            .setBodyBackgroundColor(bcolor)
            .setBodyBorderColor(bcolor)
            .setLineColor(bcolor)
            .setQuantityBackgroundColor("#1E2746")
            .setQuantityBorderColor("#000")
            .setQuantityTextColor('#fff')
            .setBodyTextColor('#fff')
        },
        scrollUp(){
            $('#studytools').scrollTop($('#studytools').scrollTop() - 40)
        },
        scrollDown(){
            // console.log('scrollTop',$('#studytools')[0].scrollHeight - $('#studytools').outerHeight())
            // $('#studytools').scrollTop($('#studytools')[0].scrollHeight - $('#studytools').outerHeight())
            $('#studytools').scrollTop($('#studytools').scrollTop() + 40)
        },
        changeNewChart(){
            const _that = this
            if(_that.tvWidget){
                if(_that.positionList.length){
                    _that.positionList.forEach((val,index) =>{
                        if(_that.positionList[index]._data){
                            _that.positionList[index].remove();
                        }
                        if(index == _that.positionList.length-1){
                            _that.positionList = []
                        }
                    })
                }
                if(_that.pendingOdList.length){
                    _that.pendingOdList.forEach((val,index) =>{
                        if(_that.pendingOdList[index]._data){
                            _that.pendingOdList[index].remove();
                        }
                        if(index == _that.pendingOdList.length-1){
                            _that.pendingOdList = []
                        }
                    })
                }
                if(_that.stopLossList.length){
                    _that.stopLossList.forEach((val,index) =>{
                        if(_that.stopLossList[index]._data){
                            _that.stopLossList[index].remove();
                        }
                        if(index == _that.stopLossList.length-1){
                            _that.stopLossList = []
                        }
                    })
                }
                if(_that.TakeProfitList.length){
                    _that.TakeProfitList.forEach((val,index) =>{
                        if(_that.TakeProfitList[index]._data){
                            _that.TakeProfitList[index].remove();
                        }
                        if(index == _that.TakeProfitList.length-1){
                            _that.TakeProfitList = []
                        }
                    })
                }
                this.tvWidget.setSymbol(this.loadChart, '1', ()=>{ 
                    _that.showLine = true
                    window.symbolss = _that.loadChart
                    _that.drawOrdersLine()
                    _that.drawStopLossAndProfit()
                });

                
            }
        },
        createFeed(){
            const _that = this
            return {
                onReady:(cb)=>{
                    setTimeout(() =>{
                        cb({
                            "supports_search": true,
                            "supports_group_request": false,
                            "supports_marks": true,
                            "supports_timescale_marks": true,
                            "supports_time": true,
                            "exchanges": [
                                
                            ],
                            "symbols_types": [
                                { name: "All", value: "" },
                                { name: "Forex", value: "Forex" },
                                { name: "Indices", value: "INDICIES" },
                                { name: "Commodities", value: "Commodities" },
                                { name: "Cryptos", value: "crypto" }
                            ],
                            "supported_resolutions": [
                                "1",
                                "5",
                                "15",
                                "30",
                                "60",
                                "240",
                                "1D",
                                "1W",
                                "1M"
                            ]
                        })
                    })

                },
                searchSymbols:async(userInput, exchange, symbolType, onResultReadyCallback)=>{
                    if( !userInput){ 
                        if(Object.keys(this.instruments).length){
                            if(symbolType){
                                this.searchdata = Object.values(this.instruments).filter(val => val.other.type.toLowerCase() == symbolType.toLowerCase());
                                onResultReadyCallback(Object.values(this.searchdata).map(v=>{
                                    return { "symbol": v.other.isinid, "full_name": v.other.mn, "description": v.other.Description, "exchange": '', "type": "" }
                                }))
                            }else{
                                this.searchdata = Object.values(this.instruments);
                                onResultReadyCallback(Object.values(this.searchdata).map(v=>{
                                    return { "symbol": v.other.isinid, "full_name": v.other.mn, "description": v.other.Description, "exchange": '', "type": "" }
                                })) 
                            }
                        }else{
                            onResultReadyCallback([]);
                        }
                    }   
                    else{
                        if(Object.keys(this.instruments).length){
                            if(symbolType){
                                this.searchdata = Object.values(this.instruments).filter(val => val.other.type.toLowerCase() == symbolType.toLowerCase());
                                onResultReadyCallback(Object.values(this.searchdata).map(v=>{
                                    return { "symbol": v.other.isinid, "full_name": v.other.mn, "description": v.other.Description, "exchange": '', "type": "" }
                                }))
                            }else{
                                this.searchdata = Object.values(this.instruments).filter(v => v.other.isinid.toLowerCase().includes(userInput.trim().toLowerCase()));
                                onResultReadyCallback(Object.values(this.searchdata).map(v=>{
                                    return { "symbol": v.other.isinid, "full_name": v.other.mn, "description": v.other.Description, "exchange": '', "type": "" }
                                }))
                            }
                        }else{
                            onResultReadyCallback([]);
                        }

                    }
                },
                resolveSymbol:async(symbolName, onSymbolResolvedCallback, onResolveErrorCallback, extension) => {
                    // console.log('[resolveSymbol]: Resolve Method call',symbolName);
                    if(this.searchdata.length){
                        let i = this.searchdata.map(v=>v.other.isinid).indexOf(symbolName)
                        if(i != -1){
                            this.searchSymbol = this.searchdata[i].other.isinid
                        }
                    }
                    try {
                        setTimeout(() =>{

                            // console.log(parseFloat(_that.instruments[_that.loadChart].other.Tick_Value));
                            onSymbolResolvedCallback({
                                "name": (this.searchSymbol) ? this.searchSymbol : this.loadChart,
                                "symbol": (this.searchSymbol) ? this.searchSymbol : this.loadChart,
                                "description": (this.searchSymbol) ? this.searchSymbol : this.loadChart,
                                "type": '',
                                "ticker": (_that.searchSymbol) ? _that.searchSymbol : _that.loadChart,
                                "minmov": 1,
                                "minmov2": 0,
                                "pointvalue": 1,
                                "pricescale": 100000,
                                "has_intraday": true,
                                "has_no_volume": true, // FIXME p3, true for Index, hense parameterize
                                "has_weekly_and_monthly": true,
                                "session": '24x7',
                                "timezone": "Etc/UTC",
                                // "exchange": "America/New_York",
                                // "monthly_multipliers" : ['1','12'],
                                "supported_resolutions": ["1", "5", "15", "30", "60", "120", "240", "480", "1D", "1W", "1M"]
                            })
                        },100);
                    }catch(e){
                        console.log('eee',e)
                    }
                },
                getBars:async(symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {
                    // console.log('[getBars]: Bar Method call', symbolInfo);
                    const { from, to, firstDataRequest, countBack } = periodParams;
                    
                        let bar = [];
                        let form = {
                            isin : (this.searchSymbol) ? this.searchSymbol : this.loadChart,
                            startdate : moment(from,'X').format('YYYYMMDDHHmm'),
                            enddate : moment(to,'X').format('YYYYMMDDHHmm'),
                            interval : this.intervalJson[resolution]
                        }
                        this._rungetChartData({ 'globalParams' : {},'localParams' : {'parameter' : this,'link' : this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].settings.patchers.SecurityMasterPatcher.DW_HOST+'/api/provider/charting?isin='+form.isin+'&startdate='+form.startdate+'&enddate='+form.enddate+'&interval='+this.intervalJson[resolution]+'&count='+countBack} }).then((response) =>{
                            if(response.length){
                                let price_detail = _that.instruments[form.isin] || {};
                                let PSHFTB = Number(_that.priceShift[form.isin+'B'] || 0)
                                let formatDigit = (v) => {
                                    if(price_detail.other && price_detail.other.market_ContractSize && PSHFTB){
                                        let newP = Number((Number(v) + PSHFTB).toFixed(price_detail.other.market_ContractSize.length - 1))
                                        // console.log('-1',Number(v),newP,PSHFTB)
                                        return newP
                                    }else{
                                        // console.log('-2')
                                        return v;
                                    }
                                }
                                response.forEach((v) =>{
                                    let date = moment(v.time).format('X');
                                    if(v=> date >= from && date < to){
                                        let json = {};
                                        // let newClose = (close && formatDigit(v.high) >= parseFloat(close) && formatDigit(feeddata[0].low) <= parseFloat(close)?close:formatDigit(v.close))
                                        json = { 
                                            "time": parseInt(moment(v.time).utc().format('X'))*1000,
                                            "open": formatDigit(v.open),
                                            "high": formatDigit(v.high),
                                            "low": formatDigit(v.low),
                                            // "close": (feeddata.length == 0 || i == feeddata.length-1)?newClose:(formatDigit(v.close)),
                                            "close": formatDigit(v.close),
                                            "volume": v.volume,
                                        }
                                        bar.push(json)
                                    }
                                })
                                // console.log('data',bar)

                                this.currentInterval = this.intervalJson[resolution]
                                this.lastBar = bar[bar.length-1]

                                onHistoryCallback(bar,{ noData: false })
                            }else{
                                if (firstDataRequest){
                                    onHistoryCallback(bar, { noData: true });
                                }else{
                                    onHistoryCallback(bar, { noData: true, nextTime: to });
                                }
                            }
                        }).catch(e=>{
                            // console.log('e',e)
                            if (firstDataRequest){
                                onHistoryCallback(bar, { noData: false });
                            }else{
                                onHistoryCallback(bar, { noData: false, nextTime: to });
                            }
                        })
                    
                },
                subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscriberUID, onResetCacheNeededCallback) => {
                    window.callbackFunction  = onRealtimeCallback
                    window.symbolss = symbolInfo.name

                    
                },
                unsubscribeBars:()=>{},
                getMarks:()=>{},
                getTimescaleMarks:()=>{},
                getServerTime:()=>{},
                getVolumeProfileResolutionForPeriod:()=>{}
            }
        },
        drawStopLossAndProfit(){
            let _that = this
            if(this.showLine){
                if(_that.openTradeList.length > 0){
                    try{
                        // _.CIQ.ChartEngine.prototype.append("draw", function(){
                            _that.openTradeList.forEach((val,index) =>     {
                                if(val.Symbol == _that.loadChart){
                                    // let data = _that.tvWidget.chart().createPositionLine();
                                    // let data1 = _that.tvWidget.chart().createPositionLine();
                                    // _that.stopLossList.push(data);
                                    // _that.TakeProfitList.push(data1);
                                    if(_that.tradeSl_TP(val,'S').Price){
                                        let data = _that.tvWidget.chart().createPositionLine();
                                        _that.stopLossList.push(data);
                                        _that.drawStopLossLine(_that.tradeSl_TP(val,'S').Price, val.Side, 'dashed', val,data) // "solid","dashed","dotted"
                                    }
                                    if(_that.tradeSl_TP(val,'L').Price){
                                        let data1 = _that.tvWidget.chart().createPositionLine();
                                        _that.TakeProfitList.push(data1);
                                        _that.drawTakeProfitLine(_that.tradeSl_TP(val,'L').Price, val.Side, 'dashed', val,data1) // "solid","dashed","dotted"
                                    }
                                }
                                if(index == _that.openTradeList.length-1){
                                    // _that.chartReady = false
                                    // clearInterval(intervalData);
                                }
                            })
                        // })
                    }catch(e){
                        console.log('ex',e)
                    }
                }
            }
        },
        tradeSl_TP(list,type){
            try{
                let close = this.pendingOrderList.filter(val=>(val.TradeID == list.TradeID || val.ToClose == list.TradeID || val.OpenOrderID == list.TradeID || (list.OpenOrderID && val.ToClose == list.OpenOrderID)) && val.Type == type)
                return (close.length)?close[0]:''
            }catch(e){ return ''}
        },
        drawOrdersLine(){
            let _that = this
            if(this.showLine){
                if(_that.openTradeList.length > 0){
                    try{
                        // _.CIQ.ChartEngine.prototype.append("draw", function(){
                            _that.openTradeList.forEach((val,index) =>     {
                                if(val.Symbol == _that.loadChart){
                                    if(_that.instruments){
                                        let data = _that.tvWidget.chart().createPositionLine()
                                        _that.positionList.push(data);
                                        _that.drawPositionLine(val.Price, val.Side, 'dotted', val,data) // "solid","dashed","dotted"
                                    }
                                }
                                if(index == _that.openTradeList.length-1){
                                    // _that.chartReady = false
                                    // clearInterval(intervalData);
                                }
                            })
                        // })
                    }catch(e){}
                }
                if(_that.pendingOrderList.length > 0){
                    try{
                        // _.CIQ.ChartEngine.prototype.append("draw", function(){
                            _that.pendingOrderList.forEach((val,index) =>     {
                                if(val.Type=='EL' || val.Type=='ES' && val.Symbol == _that.loadChart){
                                    if(_that.instruments){
                                        let data1 = _that.tvWidget.chart().createPositionLine();
                                        _that.pendingOdList.push(data1);
                                            _that.drawOrderLine(val.Price, val.Side, 'dashed', val,data1) // "solid","dashed","dotted"
                                    }
                                }
                                if(index == _that.pendingOrderList.length-1){
                                    // console.log('this.chartReady ========> closed',_that.chartReady)
                                    // _that.chartReady = false
                                    // clearInterval(intervalData1);
                                    // console.log('intervalData closed')
                                }
                            })
                        // })
                    }catch(e){}
                }
                this.IsLineDraw = true
                // this.drawStopLossAndProfit()
            }
        },
        startChart(){
            const _that = this
            const themeStyle = getComputedStyle(document.body);
            setTimeout(function(){_that.feed = _that.createFeed()},400);
            setTimeout(function(){
                const container = _that.$refs.chartContainer;
                var widgetOptions = {
                    // library_path: '../../../../static/website/js/charting_library/',
                    library_path: 'static/tv/charting_library/',
                    // debug: true, // uncomment this line to see Library errors and warnings in the console
                    fullscreen: true,
                    symbol: _that.loadChart || _that.info.other.isinid,
                    interval: '1',
                    container: container,
                    datafeed: _that.feed,
                    locale: "en",
                    disabled_features: ['header_compare'],
                    // enabled_features: [],
                    // enabled_features: ["chart_template_storage","save_chart_properties_to_local_storage","saveload_separate_drawings_storage","header_saveload"],
                    enabled_features: ["chart_template_storage"],
                    theme: "dark",
                    header_widget_buttons_mode: 'adaptive',
                    time_frames: [
                        { text: "1d", resolution: "1", description: "1 day" },
                        { text: "5d", resolution: "5", description: "5 days" },
                        { text: "1m", resolution: "30", description: "1 Month" },
                        { text: "3m", resolution: "60", description: "3 Months" },
                        { text: "6m", resolution: "120", description: "6 Months" },
                        { text: "1Y", resolution: "1D", description: "3 Years" },
                        { text: "5Y", resolution: "1W", description: "5 Years" },
                    ],
                    autosize: true,
                    mouse_wheel_scroll: true,
                    toolbar_bg: themeStyle.getPropertyValue('--primary-color'),
                    overrides: {},
                    // timezone: "Etc/UTC",
                };
                // let tvChartLocal = 

                console.log('===>',widgetOptions)
                const tvWidget = new TradingView.widget(widgetOptions);
                tvWidget.onChartReady(() => {
                    _that.tvWidget = tvWidget;
                    _that.loading = 0
                    _that.showLine = true
                    // _that.drawOrdersLine()
                    _that.drawStopLossAndProfit()
                    tvWidget.applyOverrides({
                        "paneProperties.backgroundGradientStartColor": themeStyle.getPropertyValue('--secondary-color'),
                        "paneProperties.backgroundGradientEndColor": themeStyle.getPropertyValue('--secondary-color'),
                        "paneProperties.vertGridProperties.color": themeStyle.getPropertyValue('--primary-color'),
                    });
                    // tvWidget.onSymbolResolved(() => {
                    //     alert('yes')
                    //     // After symbol resolution, remove the symbol info
                    //     tvWidget.chart().removeSymbolOverlay();
                    // });
                    // var syminfo =  _that.tvWidget.chart()._alignerSymbolInfo.symbol;
                });
            }, 1000)
        }
    },
   	computed: {
        create_liveCandle_prev(){
            try{

                const symbol = window.symbolss
                if(this.instruments[symbol]){
                    if(!this.IsLineDraw){
                        this.drawOrdersLine()
                    }
                    let currentMin = moment().minutes()
                    this.lastMin = moment(this.lastBar['time']/1000).minute()
                    let last5Min = moment(this.lastBar['time']/5000).minute()
                    let last15Min = moment(this.lastBar['time']/15000).minute()
                    let last30Min = moment(this.lastBar['time']/30000).minute()

                    let currentHour = moment().hours()
                    let hours = moment(this.lastBar['time']/1000).hours()
                    let Fourhours = moment(this.lastBar['time']/4000).hours()

                    let currentWeek = moment().weeks()
                    let oneWeek = moment(this.lastBar['time']).add('1','weeks').weeks()

                    
                    
                    if((this.lastBar == ''|| this.lastMin != currentMin) && this.currentInterval == '1m'){
                        this.lastBar = 
                        {
                            "time": parseInt(moment().format('X'))*1000,
                            "open": this.instruments[symbol].B,
                            "high": this.instruments[symbol].B,
                            "low": this.instruments[symbol].B,
                            "close": this.instruments[symbol].B,
                            // "volume": 0,
                        }
                        this.lastMin = currentMin
                    }
                    if((this.lastBar == ''|| this.lastMin != last5Min) && this.currentInterval == '5m'){
                        this.lastBar = 
                        {
                            "time": parseInt(moment().format('X'))*1000,
                            "open": this.instruments[symbol].B,
                            "high": this.instruments[symbol].B,
                            "low": this.instruments[symbol].B,
                            "close": this.instruments[symbol].B,
                            // "volume": 0,
                        }
                        this.lastMin = last5Min
                    }
                    if((this.lastBar == ''|| this.lastMin != last15Min) && this.currentInterval == '15m'){
                        this.lastBar = 
                        {
                            "time": parseInt(moment().format('X'))*1000,
                            "open": this.instruments[symbol].B,
                            "high": this.instruments[symbol].B,
                            "low": this.instruments[symbol].B,
                            "close": this.instruments[symbol].B,
                            // "volume": 0,
                        }
                        this.lastMin = last15Min
                    }
                    if((this.lastBar == ''|| this.lastMin != last30Min) && this.currentInterval == '30m'){
                        this.lastBar = 
                        {
                            "time": parseInt(moment().format('X'))*1000,
                            "open": this.instruments[symbol].B,
                            "high": this.instruments[symbol].B,
                            "low": this.instruments[symbol].B,
                            "close": this.instruments[symbol].B,
                            // "volume": 0,
                        }
                        this.lastMin = last30Min
                    }
                    if((this.lastBar == ''|| currentHour != hours) && this.currentInterval == '1h'){
                        this.lastBar = 
                        {
                            "time": parseInt(moment().format('X'))*1000,
                            "open": this.instruments[symbol].B,
                            "high": this.instruments[symbol].B,
                            "low": this.instruments[symbol].B,
                            "close": this.instruments[symbol].B,
                            // "volume": 0,
                        }
                        this.lastMin = hours
                    }
                    if((this.lastBar == ''|| currentHour != Fourhours) && this.currentInterval == '4h'){
                        this.lastBar = 
                        {
                            "time": parseInt(moment().format('X'))*1000,
                            "open": this.instruments[symbol].B,
                            "high": this.instruments[symbol].B,
                            "low": this.instruments[symbol].B,
                            "close": this.instruments[symbol].B,
                            // "volume": 0,
                        }
                        this.lastMin = Fourhours
                    }

                    if(this.lastBar == '' && this.currentInterval == '1day'){

                        this.lastBar = 
                        {
                            "time": parseInt(moment().format('X'))*1000,
                            "open": this.instruments[symbol].B,
                            "high": this.instruments[symbol].B,
                            "low": this.instruments[symbol].B,
                            "close": this.instruments[symbol].B,
                            // "volume": 0,
                        }

                        this.lastMin = currentMin
                    }
                    if((this.lastBar == ''|| currentWeek != oneWeek) && this.currentInterval == '1week'){
                        this.lastBar = 
                        {
                            "time": parseInt(moment().format('X'))*1000,
                            "open": this.instruments[symbol].B,
                            "high": this.instruments[symbol].B,
                            "low": this.instruments[symbol].B,
                            "close": this.instruments[symbol].B,
                            // "volume": 0,
                        }
                        this.lastMin = oneWeek
                    }
                    
                    let high = this.lastBar.high < this.instruments[symbol].B ? this.instruments[symbol].B  : this.lastBar.high
                    let low = this.lastBar.low > this.instruments[symbol].B ? this.instruments[symbol].B  : this.lastBar.low

                    this.lastBar = {
                        "time": parseInt(moment().format('X'))*1000,
                        "open": parseFloat(this.lastBar.open),
                        "high": parseFloat(high),
                        "low": parseFloat(low),
                        "close": parseFloat(this.instruments[symbol].B),
                        // "volume": this.lastBar.volume,
                    }
                    
                    
                    "callbackFunction" in window ? window.callbackFunction(this.lastBar) : ''
                    return this.instruments[symbol].B
                }

            }  catch(ex){
                console.log("ex in charting app", ex)
            }
        },
        create_liveCandle() {
            try {
                const symbol = window.symbolss;
                const instrument = this.instruments[symbol];

                if (instrument) {
                    if (!this.IsLineDraw) this.drawOrdersLine();

                    const now = moment();
                    const currentMin = now.minutes();
                    const timeIntervals = {
                        "1m": { min: currentMin },
                        "5m": { min: moment(this.lastBar.time / 5000).minute() },
                        "15m": { min: moment(this.lastBar.time / 15000).minute() },
                        "30m": { min: moment(this.lastBar.time / 30000).minute() },
                        "1h": { hour: now.hours() },
                        "4h": { hour: moment(this.lastBar.time / 4000).hours() },
                        "1day": { day: currentMin },
                        "1week": { week: now.weeks() },
                    };

                    const interval = timeIntervals[this.currentInterval] || {};

                    if (this.lastBar === "" || this.lastMin !== interval.min || this.lastMin !== interval.hour || this.lastMin !== interval.week) {
                        this.lastBar = {
                            time: parseInt(now.format("X")) * 1000,
                            open: instrument.B,
                            high: instrument.B,
                            low: instrument.B,
                            close: instrument.B,
                        };
                        this.lastMin = interval.min || interval.hour || interval.week;
                    }

                    const high = Math.max(this.lastBar.high, instrument.B);
                    const low = Math.min(this.lastBar.low, instrument.B);

                    this.lastBar = {
                        time: parseInt(now.format("X")) * 1000,
                        open: parseFloat(this.lastBar.open),
                        high: parseFloat(high),
                        low: parseFloat(low),
                        close: parseFloat(instrument.B),
                    };

                    if ("callbackFunction" in window) window.callbackFunction(this.lastBar);
                    return instrument.B;
                }
            } catch (ex) {
                console.log("ex in charting app", ex);
            }
        },
	   	instruments() {
    	    try {               
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {                
	            return []
	        }
	    },
        get_currencies(){
            try {
                this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
                return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
                .iCache.asKeysValueArrayAll()
            } catch (ex) {
                // console.log('OO-one [ex]', ex)
                return []
            }
        },
        set_order_draw_line(){
                
            if(this.OldTrade !== this.openTradeList && this.tvWidget!=null) { this.OldTrade = this.openTradeList;}
            // this.drawOrdersLine();
            
            return this.openTradeList
        },
   	},
    mounted(){
        // this.feed = this.createFeed()
        // this.loadScripts().then(() => {
        this._runGetpriceShift({ globalParams: {}, localParams: { parameter: this } });
        // setTimeout(function(){_that.feed = _that.createFeed()},400);
        // });
        
    },
}
</script>



// WEBPACK FOOTER //
// src/components/website/shared/trading-view.vue